import PropTypes from 'prop-types'


export const propTypes = {
  icon: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
}
